import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { OrnateDivider } from './Dividers';
const tiers = [{
  name: 'Wanderer',
  price: '0',
  description: 'For emerging creators beginning their journey.',
  features: ['Up to 5 syndication channels', 'Basic audience analytics', 'Community guild support', 'Standard ad placements'],
  highlighted: false
}, {
  name: 'Sentinel',
  price: '149',
  description: 'For established publishers commanding a loyal following.',
  features: ['Up to 25 syndication channels', 'Premium CPMs (€12-€28 avg)', 'Full Oracle Dashboard access', 'Priority audience matching', 'Lore-matched ad targeting'],
  highlighted: true
}, {
  name: 'Archon',
  price: '449',
  description: 'For vast networks and studios shaping the realm.',
  features: ['Unlimited syndication channels', 'Dedicated realm strategist', 'Custom seasonal campaigns', 'Full API access', 'White-label options'],
  highlighted: false
}];
export const Pricing = () => {
  return <section id="pricing" className="py-24 bg-burgundy-950 relative" data-id="element-130">
      <div className="absolute inset-0 bg-dark-parchment opacity-50" data-id="element-131"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-132">
        <div className="text-center mb-16" data-id="element-133">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl text-gold-500 mb-4" data-id="element-134">
            Choose Your Path
          </motion.h2>
          <p className="text-xl text-parchment-200 max-w-2xl mx-auto" data-id="element-135">
            Whether you walk alone or command an army, there is a covenant
            suited for your ambitions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center" data-id="element-136">
          {tiers.map((tier, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className={`relative p-8 ${tier.highlighted ? 'bg-burgundy-900 border-ornate shadow-gold-glow transform md:-translate-y-4' : 'bg-burgundy-900/40 border border-gold-700/30'}`} data-id="element-137">
              {tier.highlighted && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-600 text-burgundy-950 px-4 py-1 font-heading text-sm font-bold uppercase tracking-widest whitespace-nowrap" data-id="element-138">
                  Most Chosen
                </div>}

              <div className="text-center mb-8 border-b border-gold-700/30 pb-8" data-id="element-139">
                <h3 className="font-heading text-2xl font-bold text-parchment-100 mb-2 uppercase tracking-widest" data-id="element-140">
                  {tier.name}
                </h3>
                <p className="text-parchment-300 text-sm mb-6 h-10" data-id="element-141">
                  {tier.description}
                </p>
                <div className="flex justify-center items-start" data-id="element-142">
                  <span className="text-gold-500 text-2xl mt-2 mr-1" data-id="element-143">€</span>
                  <span className="font-display text-6xl text-gold-400" data-id="element-144">
                    {tier.price}
                  </span>
                  <span className="text-parchment-300 self-end mb-2 ml-1" data-id="element-145">
                    /mo
                  </span>
                </div>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-146">
                {tier.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3 text-parchment-200" data-id="element-147">
                    <CheckIcon className="w-5 h-5 text-gold-500 shrink-0 mt-0.5" data-id="element-148" />
                    <span data-id="element-149">{feature}</span>
                  </li>)}
              </ul>

              <button className={`w-full py-3 font-heading font-bold uppercase tracking-widest transition-all ${tier.highlighted ? 'bg-gold-600 text-burgundy-950 hover:bg-gold-500 shadow-lg' : 'border border-gold-600 text-gold-500 hover:bg-gold-600/10'}`} data-id="element-150">
                Pledge Fealty
              </button>
            </motion.div>)}
        </div>

        <OrnateDivider className="mt-20" data-id="element-151" />
      </div>
    </section>;
};